import Icon from '../components/Icon.vue'

Icon.register({
  'file-download': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM300.4 347.4L204 443.1C197.4 449.7 186.6 449.7 180 443.1L83.6 347.4C73.4 337.3 80.5 320 94.8 320H160V240C160 231.2 167.2 224 176 224H208C216.8 224 224 231.2 224 240V320H289.2C303.5 320 310.6 337.3 300.4 347.4zM377 105L279.1 7C274.6 2.5 268.5 0 262.1 0H256V128H384V121.9C384 115.6 381.5 109.5 377 105z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-download.js
// module id = /tik
// module chunks = 144